/*
 *
 * Application Main
 *
 */
!(function(APP) {
    'use strict';


    var breakpoint = 768;

    $.extend(true, APP, {
        breakpoint: breakpoint,
        init: {
            menu: () => {
                var doc = window.document.documentElement,
                    navItems = document.querySelectorAll('.navbar-nav .nav-link'),
                    navToggler = document.querySelector('.nav-toggler'),
                    hasSubmenuItems = [];

                const menuHandle = (li, isTopLevel) => {

                    const a = li.querySelector('a');

                    if (APP.browser.mobile) {
                        a.addEventListener('click', (e) => {
                            e.preventDefault();
                            li.classList.toggle('active');
                            doc.classList.add('open-menu');
                        });
                    } else {
                        li.addEventListener('mouseenter', () => {
                            $(li).siblings().each((i, item) => {
                                item.classList.remove('active');
                            });

                            li.classList.add('active');
                            if (isTopLevel) {
                                doc.classList.add('open-menu');
                            }
                        });

                        li.addEventListener('mouseleave', () => {
                            if (li.classList.contains('active')) {
                                li.classList.remove('active');

                                if (isTopLevel) {
                                    doc.classList.remove('open-menu');
                                }
                            }
                        });
                    }
                };

                [...navItems].forEach(el => {
                    if (el.nextElementSibling && el.nextElementSibling.classList && el.nextElementSibling.classList.contains('submenu-container')) {
                        const li = el.parentNode;
                        const icon = document.createElement('span');
                        icon.classList.add('ms-icon', 'ms-icon-arrow-down');
                        el.appendChild(icon);
                        menuHandle(li, true);
                        hasSubmenuItems.push(li);
                        const subMenus = li.querySelectorAll('.menu > li > .item');
                        subMenus.forEach(el => {
                            var sibling = el.nextElementSibling && el.nextElementSibling.nextElementSibling;
                            if (sibling && sibling.classList && sibling.classList.contains('sub-menu')) {
                                const lip = el.parentNode;
                                menuHandle(lip);
                            }
                        });
                        $('.menu > li > a > .icons').on('click', function(e) {
                            e.preventDefault();
                        });
                    }
                });

                if (APP.browser.mobile) {
                    navToggler.addEventListener('click', () => {
                        doc.classList.toggle('open-menu');
                    });
                }

                $('.back-to-parent').on('click', function() {
                    $(this).closest('li.active').removeClass('active');
                });
            },
            modal: () => {
                $('.modal.open').modal('show');
            },
            slideAnimation: () => {
                var sliderTimer = 7000;
                var $imageSlider = $('.slide-animation');
                function progressBar() {
                    $('.slider-progress').find('span').removeAttr('style');
                    $('.slider-progress').find('span').removeClass('active');
                    setTimeout(function() {
                        $('.slider-progress').find('span').css('transition-duration', (sliderTimer / 1000) + 's').addClass('active');
                    }, 100);
                }
                progressBar();
                $imageSlider.on('beforeChange', function() {
                    progressBar();
                });
            },
            search: () => {

                var search = $('#search');

                search.on('shown.bs.collapse', () => {
                    $('.search-input').get(0).focus();

                    $(document.body).on('click.close-search', (e) => {
                        var target = $(e.target);
                        var cond = target === search || target.parents('#search').length;

                        if (!cond) {
                            search.collapse('hide');
                        }
                    });
                });

                search.get(0).addEventListener('hide.bs.collapse', () => {
                    $(document.body).off('click.close-search');
                });
            },
            tabInSlick: () => {

                $('[data-bs-toggle="tab"]').on('shown.bs.tab', function (event) {
                    var target = $(event.target).data('bsTarget');
                    target = $(target);
                    target = $('[data-slick]', target).get(0);
                    target.slick.setPosition(); // eslint-disable-line
                    target.slick.slickGoTo(0); // eslint-disable-line
                });
            },
            karosel: () => {
                const container = $('[data-slick-type="customers-comment"]');

                if (!container.length) {
                    return;
                }

                const items = container.find('.slider-item');
                let itemsCount = items.length;

                container.parent().removeClass('carousel');

                while (itemsCount < 4) {
                    for (let i = 0; i < items.length; i++) {
                        if (itemsCount > 3) {
                            break;
                        }
                        const clone = items.eq(i).clone();
                        container.append(clone);
                        itemsCount++;
                    }
                }

                container.parent().addClass('carousel');
                APP.init.carousel();
            }
        },

        INIT: function(options) {
            // APP init

            options = options || {};

            var fn;

            for (var i in this.init) {
                if ( Object.prototype.hasOwnProperty.call(this.init, i) && i.charAt(0) !== '_' && typeof(fn = this.init[i]) === 'function' ) {
                    fn.call(this, options && options[i] || options);
                }
            }

            return this;
        }
    });

})(window.APP = window.APP || {});

$(function() {
    'use strict';

    APP.browser = (function() {

        var is = APP.Helper.is,
            val, tmp,
            userAgent = APP.sanitizeXss(navigator.userAgent);

        var browser = {
            mobile: !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile/i.test(userAgent),
            ios: !!/iPhone|iPad|iPod/i.test(userAgent),
            ie: (tmp = userAgent.toLowerCase().match(/MSIE ([^;]+)|rv:(11)\.[0-9]+/i)) ? parseInt(tmp[1] || tmp[2], 10) : false,
            edge: (tmp = userAgent.indexOf('Edge/')) > 0 ? parseInt(userAgent.substring(tmp + 5, userAgent.indexOf('.', tmp)), 10) : false,
            bp: function() {
                return $(window).width() < APP.breakpoint;
            }
        };

        var $el = $('html'); // document.documentElement

        for (var k in browser ) {
            if ( Object.prototype.hasOwnProperty.call(browser, k) ) {
                val = browser[k];

                if ( val && !is.function(val) ) {
                    $el.addClass(k);
                    if ( !is.boolean(val) ) {
                        $el.addClass(k + val);
                    }
                }
            }
        }

        APP.browser = browser;

        return browser;
    }());

    APP.scriptPath = APP.Helper.getScriptPath(['app.js', 'app.min.js', 'main.js']);

    APP.Helper.loadScript(APP.scriptPath + 'config.js', {
        success: function() {
            APP.INIT(CONFIG);
        },
        failed: function() {
            APP.INIT();
        }
    });
});
